// extracted by mini-css-extract-plugin
export default {"wrapper":"uy-z","viewport":"vy-z","container":"wy-z","slide":"xy-z"};